import ENDPOINTS from 'api/endpoints';
import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { TemplateProject } from './types';

export const getTemplateProject = (id: string) => {
  return doGet<TemplateProject>(
    generateNextPath(ENDPOINTS.TEMPLATE_PROJECT, {
      id,
    }),
    LOGGER_TYPE.JUPITER,
    { version: 'v2' },
  );
};
